import { render, staticRenderFns } from "./couponSheetItem.vue?vue&type=template&id=3345b050&scoped=true&lang=html&"
import script from "./couponSheetItem.vue?vue&type=script&lang=js&"
export * from "./couponSheetItem.vue?vue&type=script&lang=js&"
import style0 from "./couponSheetItem.vue?vue&type=style&index=0&id=3345b050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3345b050",
  null
  
)

export default component.exports